

export class CountryAddInput implements ICountryAddInput {
    /** The country name with 255 character limit */
    countryName!: string;

    constructor(data?: ICountryAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): CountryAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new CountryAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        return data; 
    }
}

export interface ICountryAddInput {
    /** The country name with 255 character limit */
    countryName: string;
}

